import { useQuery } from '@tanstack/react-query';
import useSelectedEnv from '@elementary/common-ui/hooks/useSelectedEnv';
import { CLOUD_TEST_FEEDBACKS } from '@elementary/common-ui/constants/queryKeys';
import * as api from 'shared/services/api';

const useCloudTestFeedbacks = ({
  testId,
  start,
  end,
  enabled,
}: {
  testId: string;
  start?: string;
  end?: string;
  enabled: boolean;
}) => {
  const selectedEnvId = useSelectedEnv();

  return useQuery({
    queryKey: [CLOUD_TEST_FEEDBACKS, selectedEnvId, testId, start, end],
    queryFn: () =>
      api.getCloudTestFeedbacks(selectedEnvId!, [testId], start, end),
    enabled: enabled && !!selectedEnvId,
  });
};

export default useCloudTestFeedbacks;
